import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-with-two-buttons',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './modal-with-two-buttons.component.html',
  styleUrls: ['./modal-with-two-buttons.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalWithTwoButtonsComponent implements OnInit {
  @Output() actionButton = new EventEmitter<void>();

  readonly nzModalData = inject(NZ_MODAL_DATA);
  dataModal: any;

  constructor(private modalRef: NzModalRef) {}

  ngOnInit() {
    this.dataModal = this.nzModalData.dataModal;
  }

  protected onAction(): void {
    this.dataModal?.actionButton();
  }

  protected onBack(): void {
    this.modalRef.close();
  }
}
